import { Box } from "@mui/material";
import styled from "styled-components";

export const WelcomePageStyled= styled(Box)`
    display: flex;
    flex-direction: column;
    row-gap: 24px;
`